import { useState, useEffect } from 'react';
import { EventSettings } from '../types';
import { eventSettingsService } from '../services/api';

export const useEventSettings = () => {
  const [settings, setSettings] = useState<EventSettings[]>([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState<string | null>(null);

  useEffect(() => {
    fetchSettings();
  }, []);

  const fetchSettings = async () => {
    try {
      setLoading(true);
      const data = await eventSettingsService.getAll();
      setSettings(data);
    } catch (err) {
      setError('Error al cargar configuraciones');
      console.error('Error fetching event settings:', err);
    } finally {
      setLoading(false);
    }
  };

  const getSettingValue = (key: string): string => {
    const setting = settings.find(s => s.setting_key === key);
    return setting?.setting_value || '';
  };

  const getExtraHourCost = (): number => {
    return parseFloat(getSettingValue('extra_hour_cost')) || 100;
  };

  const getAdvancePaymentAmount = (): number => {
    return parseFloat(getSettingValue('advance_payment_amount')) || 300;
  };

  const getDefaultEventDuration = (): number => {
    return parseInt(getSettingValue('default_event_duration')) || 4;
  };

  const getMaxExtraHours = (): number => {
    return parseInt(getSettingValue('max_extra_hours')) || 3;
  };

  return {
    settings,
    loading,
    error,
    getSettingValue,
    getExtraHourCost,
    getAdvancePaymentAmount,
    getDefaultEventDuration,
    getMaxExtraHours,
    refetch: fetchSettings,
  };
};
